import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

const StContainer = styled.div<{ readonly height?: number }>`
    position: relative;
    height: ${props => `${props.height ?? 90}px`};
`;

const StBulkMenu = styled.div<{ readonly isSticky?: boolean; readonly movedUp?: boolean }>`
    height: ${props => (props.isSticky ? null : props.movedUp ? '100%' : '0px')};
    position: ${props => (props.isSticky ? 'fixed' : 'relative')};
    top: ${props => (props.isSticky ? '44px' : null)};
    bottom: ${props => (props.isSticky ? null : 0)};
    transition: ${props => (props.isSticky ? null : 'all 0.3s ease')};
    width: 100%;
    z-index: 21;
    background-color: #ffffff;
    overflow: ${props => (props.movedUp ? null : 'hidden')};
    opacity: ${props => (props.movedUp ? '1' : '0')};
    display: ${props => (!props.movedUp && props.isSticky ? 'none' : null)};
`;

const StHeader = styled.div<{ readonly movedUp?: boolean }>`
    height: ${props => (props.movedUp ? '0px' : '100%')};
    position: relative;
    top: ${props => (props.movedUp ? '-100%' : '0%')};
    transition: all 0.3s ease;
    overflow: ${props => (props.movedUp ? 'hidden' : null)};
`;

type Props = {
    readonly movedUp?: boolean;
    readonly isSticky?: boolean;
    readonly headerHeight?: number;
    readonly headerComponent?: ReactNode;
    readonly bulkMenuComponent?: ReactNode;
};

const SelectionBulkContainer: FC<Props> = ({ headerHeight, movedUp, isSticky, headerComponent, bulkMenuComponent }) => (
    <StContainer height={headerHeight}>
        <StHeader movedUp={movedUp}>{headerComponent}</StHeader>
        <StBulkMenu movedUp={movedUp} isSticky={isSticky}>
            {bulkMenuComponent}
        </StBulkMenu>
    </StContainer>
);

export default SelectionBulkContainer;
